/* src/app/components/feedback/feedback.component.scss */
.page-heading {
  display: flex;
  align-items: center;
  gap: 14px;
}
.page-heading .page-heading-icon {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: #eef0ff;
  color: #253B80;
  font-size: 18px;
}
.page-heading h3 {
  margin: 0;
  color: #101828;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.3;
}
.page-heading p {
  margin: 4px 0 0;
  color: #667085;
  font-size: 13px;
  line-height: 1.5;
}
.feedback-section {
  width: 100%;
  padding: 24px 0 40px;
}
.feedback-container {
  width: 100%;
  max-width: 1600px;
  margin: 0 auto;
  padding: 0 24px;
}
.feedback-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 20px;
}
.feedback-summary {
  min-height: 68px;
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 18px;
  background: #ffffff;
  border: 1px solid #eaecf0;
  border-radius: 14px;
  box-shadow: 0 2px 5px rgba(16, 24, 40, 0.03);
}
.feedback-summary .summary-icon {
  width: 42px;
  height: 42px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 11px;
  background: #eef0ff;
  color: #253B80;
  font-size: 17px;
}
.feedback-summary .summary-content {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.feedback-summary .summary-content span {
  color: #667085;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.4;
}
.feedback-summary .summary-content strong {
  color: #101828;
  font-size: 21px;
  font-weight: 700;
  line-height: 1.3;
}
.search-box {
  position: relative;
  width: min(100%, 340px);
  display: flex;
  align-items: center;
}
.search-icon {
  position: absolute;
  left: 15px;
  color: #98a2b3;
  font-size: 14px;
  pointer-events: none;
}
.search-input {
  width: 100%;
  height: 44px;
  padding: 0 42px 0 42px;
  color: #101828;
  background: #ffffff;
  border: 1px solid #d0d5dd;
  border-radius: 10px;
  outline: none;
  font-family: inherit;
  font-size: 14px;
  line-height: 1.5;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.search-input::placeholder {
  color: #98a2b3;
}
.search-input:hover {
  border-color: #98a2b3;
}
.search-input:focus {
  border-color: #253B80;
  box-shadow: 0 0 0 3px rgba(99, 91, 255, 0.12);
}
.clear-search {
  position: absolute;
  right: 9px;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: #667085;
  cursor: pointer;
  font-size: 13px;
  transition: background 0.2s ease, color 0.2s ease;
}
.clear-search:hover {
  background: #f2f4f7;
  color: #344054;
}
.clear-search:focus-visible {
  outline: 2px solid #253B80;
  outline-offset: 2px;
}
.feedback-card {
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #eaecf0;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(16, 24, 40, 0.04);
}
.table-header {
  min-height: 78px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 16px 20px;
  background: #ffffff;
  border-bottom: 1px solid #eaecf0;
}
.table-heading {
  display: flex;
  align-items: center;
  gap: 12px;
}
.table-heading-icon {
  width: 38px;
  height: 38px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: #f5f3ff;
  color: #253B80;
  font-size: 15px;
}
.table-heading h4 {
  margin: 0;
  color: #101828;
  font-size: 17px;
  font-weight: 700;
  line-height: 1.4;
}
.table-heading p {
  margin: 3px 0 0;
  color: #667085;
  font-size: 13px;
  line-height: 1.5;
}
.table-heading p strong {
  color: #344054;
  font-weight: 600;
}
.table-status {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 7px 11px;
  color: #475467;
  background: #f9fafb;
  border: 1px solid #eaecf0;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}
.status-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #12b76a;
  box-shadow: 0 0 0 3px rgba(18, 183, 106, 0.12);
}
.table-wrapper {
  width: 100%;
  overflow-x: auto;
  scrollbar-width: thin;
  scrollbar-color: #d0d5dd transparent;
}
.table-wrapper::-webkit-scrollbar {
  height: 7px;
}
.table-wrapper::-webkit-scrollbar-track {
  background: #f9fafb;
}
.table-wrapper::-webkit-scrollbar-thumb {
  background: #d0d5dd;
  border-radius: 20px;
}
.feedback-table {
  width: 100%;
  min-width: 1200px;
  border-collapse: separate;
  border-spacing: 0;
}
.feedback-table th,
.feedback-table td {
  text-align: left;
  vertical-align: middle;
}
.feedback-table thead th {
  height: 56px;
  padding: 0 16px;
  background: #f8fafc;
  border-bottom: 1px solid #eaecf0;
  color: #475467;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.01em;
}
.feedback-table tbody td {
  padding: 18px 16px;
  border-bottom: 1px solid #f0f2f5;
  color: #344054;
  font-size: 13px;
}
.feedback-table tbody td:first-child {
  padding-left: 20px;
}
.feedback-table tbody td:last-child {
  padding-right: 20px;
}
.feedback-table tbody tr {
  transition: background 0.2s ease;
}
.feedback-table tbody tr:hover {
  background: #fafbff;
}
.feedback-table tbody tr:last-child td {
  border-bottom: 0;
}
.question-column {
  width: 22%;
  min-width: 230px;
}
.answer-column {
  width: 24%;
  min-width: 250px;
}
.feedback-column {
  width: 11%;
  min-width: 120px;
}
.comments-column {
  width: 17%;
  min-width: 180px;
}
.source-column {
  width: 16%;
  min-width: 180px;
}
.date-column {
  width: 10%;
  min-width: 140px;
}
.th-content {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
}
.th-icon {
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 7px;
  font-size: 12px;
}
.th-icon.question {
  background: #eef4ff;
  color: #175cd3;
}
.th-icon.answer {
  background: #f4f3ff;
  color: #6938ef;
}
.th-icon.accuracy {
  background: #ecfdf3;
  color: #039855;
}
.th-icon.comments {
  background: #fff6ed;
  color: #ec7211;
}
.th-icon.source {
  background: #f2f4f7;
  color: #475467;
}
.th-icon.date {
  background: #eff8ff;
  color: #026aa2;
}
.question-wrapper {
  max-width: 360px;
}
.question-text {
  display: -webkit-box;
  margin: 0;
  overflow: hidden;
  color: #101828;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.55;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.answer-wrapper {
  max-width: 390px;
}
.answer-preview {
  display: -webkit-box;
  max-height: 68px;
  overflow: hidden;
  color: #475467;
  font-size: 13px;
  line-height: 1.6;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.answer-preview :is(p, div) {
  margin: 0;
}
.answer-preview strong,
.answer-preview b {
  color: #344054;
}
.read-more {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 9px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #253B80;
  cursor: pointer;
  font-family: inherit;
  font-size: 12px;
  font-weight: 700;
  transition: color 0.2s ease;
}
.read-more:hover {
  color: #4b43d6;
  text-decoration: underline;
}
.read-more:focus-visible {
  outline: 2px solid #253B80;
  outline-offset: 3px;
  border-radius: 3px;
}
.feedback-badge {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 7px 10px;
  border: 1px solid transparent;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.02em;
}
.feedback-badge.like {
  color: #027a48;
  background: #ecfdf3;
  border-color: #abefc6;
}
.feedback-badge.unlike {
  color: #b42318;
  background: #fef3f2;
  border-color: #fecdca;
}
.badge-icon {
  width: 20px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.7);
  font-size: 9px;
}
.comments-content {
  max-width: 270px;
}
.comment-display {
  display: flex;
  align-items: flex-start;
  gap: 9px;
  color: #475467;
  font-size: 13px;
  line-height: 1.55;
}
.comment-display i {
  flex-shrink: 0;
  margin-top: 3px;
  color: #98a2b3;
  font-size: 13px;
}
.comment-display span {
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.source-document {
  max-width: 230px;
  display: flex;
  align-items: center;
  gap: 9px;
  color: #344054;
  cursor: default;
  font-size: 13px;
  font-weight: 500;
}
.source-document .source-icon {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #f2f4f7;
  color: #667085;
  font-size: 13px;
}
.source-document span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.date-wrapper {
  display: flex;
  align-items: center;
  gap: 9px;
}
.date-icon {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #eff8ff;
  color: #026aa2;
  font-size: 12px;
}
.date-wrapper div {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.date-wrapper div strong {
  color: #344054;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}
.date-wrapper div span {
  color: #98a2b3;
  font-size: 11px;
  white-space: nowrap;
}
.mobile-column-label {
  display: none;
}
.no-data {
  min-height: 340px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 50px 20px;
  text-align: center;
}
.no-data-icon {
  width: 64px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  border-radius: 16px;
  background: #f4f3ff;
  color: #253B80;
  font-size: 25px;
}
.no-data h5 {
  margin: 0 0 6px;
  color: #101828;
  font-size: 17px;
  font-weight: 700;
}
.no-data p {
  margin: 0;
  color: #667085;
  font-size: 13px;
  line-height: 1.6;
}
:host ::ng-deep .feedback-answer-dialog {
  overflow: hidden;
  border: 1px solid #eaecf0;
  border-radius: 16px;
  box-shadow: 0 24px 60px rgba(16, 24, 40, 0.18);
}
:host ::ng-deep .feedback-answer-dialog .p-dialog-header {
  padding: 18px 22px;
  background: #ffffff;
  border-bottom: 1px solid #eaecf0;
}
:host ::ng-deep .feedback-answer-dialog .p-dialog-header .p-dialog-title {
  color: #101828;
  font-size: 17px;
  font-weight: 700;
}
:host ::ng-deep .feedback-answer-dialog .p-dialog-header .p-dialog-header-icon {
  width: 34px;
  height: 34px;
  color: #667085;
  border-radius: 8px;
  transition: background 0.2s ease, color 0.2s ease;
}
:host ::ng-deep .feedback-answer-dialog .p-dialog-header .p-dialog-header-icon:hover {
  background: #f2f4f7;
  color: #344054;
}
:host ::ng-deep .feedback-answer-dialog .p-dialog-content {
  padding: 0;
  background: #ffffff;
}
.answer-dialog-content {
  padding: 22px;
}
.dialog-answer-header {
  display: flex;
  align-items: center;
  gap: 13px;
  margin-bottom: 20px;
  padding-bottom: 18px;
  border-bottom: 1px solid #eaecf0;
}
.dialog-answer-icon {
  width: 42px;
  height: 42px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 11px;
  background: #eef0ff;
  color: #253B80;
  font-size: 17px;
}
.dialog-answer-heading h5 {
  margin: 0;
  color: #101828;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.4;
}
.dialog-answer-heading p {
  margin: 3px 0 0;
  color: #667085;
  font-size: 13px;
  line-height: 1.5;
}
.answer-content {
  max-height: 58vh;
  overflow-y: auto;
  padding: 4px 6px 4px 2px;
  color: #344054;
  font-size: 14px;
  line-height: 1.75;
  scrollbar-width: thin;
  scrollbar-color: #d0d5dd transparent;
}
.answer-content::-webkit-scrollbar {
  width: 6px;
}
.answer-content::-webkit-scrollbar-track {
  background: transparent;
}
.answer-content::-webkit-scrollbar-thumb {
  background: #d0d5dd;
  border-radius: 20px;
}
.answer-content p {
  margin: 0 0 14px;
}
.answer-content p:last-child {
  margin-bottom: 0;
}
.answer-content strong,
.answer-content b {
  color: #101828;
  font-weight: 700;
}
.answer-content ul,
.answer-content ol {
  margin: 10px 0 16px;
  padding-left: 24px;
}
.answer-content li {
  margin-bottom: 7px;
}
.answer-content h1,
.answer-content h2,
.answer-content h3,
.answer-content h4,
.answer-content h5,
.answer-content h6 {
  margin: 18px 0 8px;
  color: #101828;
  line-height: 1.4;
}
.answer-content h3 {
  font-size: 17px;
}
.answer-content h4 {
  font-size: 16px;
}
.answer-content h5,
.answer-content h6 {
  font-size: 15px;
}
.answer-content a {
  color: #253B80;
  text-decoration: none;
}
.answer-content a:hover {
  text-decoration: underline;
}
.answer-content table {
  width: 100%;
  margin: 16px 0;
  border-collapse: collapse;
  font-size: 13px;
}
.answer-content table th,
.answer-content table td {
  padding: 9px 10px;
  border: 1px solid #eaecf0;
  text-align: left;
}
.answer-content table th {
  background: #f8fafc;
  color: #344054;
  font-weight: 700;
}
.answer-content table td {
  color: #475467;
}
@media (max-width: 1100px) {
  .feedback-container {
    padding: 0 18px;
  }
  .feedback-table {
    min-width: 1100px;
  }
  .table-header {
    padding: 16px 18px;
  }
}
@media (max-width: 768px) {
  .feedback-section {
    padding-top: 18px;
  }
  .feedback-container {
    padding: 0 14px;
  }
  .feedback-toolbar {
    flex-direction: column;
    align-items: stretch;
  }
  .feedback-summary {
    width: 100%;
  }
  .search-box {
    width: 100%;
  }
  .table-header {
    align-items: flex-start;
    flex-direction: column;
  }
  .table-status {
    align-self: flex-start;
  }
  .table-wrapper {
    overflow-x: visible;
  }
  .feedback-table {
    display: block;
    min-width: 0;
  }
  .feedback-table thead {
    display: none;
  }
  .feedback-table tbody,
  .feedback-table tr,
  .feedback-table td {
    display: block;
    width: 100%;
  }
  .feedback-table tbody tr {
    padding: 18px;
    border-bottom: 1px solid #eaecf0;
  }
  .feedback-table tbody tr:last-child {
    border-bottom: 0;
  }
  .feedback-table tbody tr:hover {
    background: #ffffff;
  }
  .feedback-table tbody td {
    padding: 0 0 16px;
    border: 0;
  }
  .feedback-table tbody td:last-child {
    padding-bottom: 0;
  }
  .feedback-table tbody td:first-child {
    padding-left: 0;
  }
  .feedback-table tbody td:last-child {
    padding-right: 0;
  }
  .mobile-column-label {
    display: block;
    margin-bottom: 6px;
    color: #667085;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.03em;
    text-transform: uppercase;
  }
  .question-wrapper,
  .answer-wrapper,
  .comments-content {
    max-width: none;
  }
  .question-text {
    font-size: 14px;
  }
  .answer-preview {
    max-height: none;
    -webkit-line-clamp: 4;
  }
  .source-document {
    max-width: 100%;
  }
  .date-wrapper {
    align-items: center;
  }
  .no-data {
    min-height: 280px;
  }
}
@media (max-width: 480px) {
  .feedback-container {
    padding: 0 10px;
  }
  .feedback-summary {
    padding: 11px 14px;
  }
  .summary-icon {
    width: 38px !important;
    height: 38px !important;
  }
  .summary-content strong {
    font-size: 19px !important;
  }
  .table-header {
    padding: 15px;
  }
  .table-heading {
    align-items: flex-start;
  }
  .table-heading-icon {
    width: 34px;
    height: 34px;
  }
  .table-heading h4 {
    font-size: 16px;
  }
  .table-heading p {
    font-size: 12px;
  }
  .feedback-table tbody tr {
    padding: 16px;
  }
  .answer-dialog-content {
    padding: 17px;
  }
  .dialog-answer-header {
    align-items: flex-start;
  }
  .answer-content {
    font-size: 13px;
    line-height: 1.7;
  }
}
@media (prefers-reduced-motion: reduce) {
  .search-input,
  .clear-search,
  .feedback-table tbody tr,
  .read-more {
    transition: none;
  }
}
/*# sourceMappingURL=feedback.component.css.map */
